import { link } from '@/constants/link';
import { apiCaller } from '@/redux/query';

/**
 * Backend-resolved deep link to activate App Embed Block in the merchant's theme editor.
 * Falls back to the themes-list URL while the API hasn't responded.
 */
export const useAppEmbedDeepLink = (): string => {
  const { data } = apiCaller.useCheckAppEmbedStatusQuery();
  return data?.deepLinkUrl || link.isOpenAppEmbedUrl;
};
